import React from "react";

export default (props) => <i className="check-icon" />;
